import React, { useEffect } from "react";

import "./floating-bar-group.css";
import { useStableCallback } from "../../hooks/useStableCallback";
import { useFloatingBar } from "./use-floating-bar";

/** This component can be used to group menu items in the top menu bar and control their visibility based on the TopMenuBar width. */
export function FloatingBarGroup({
	children,
	hideLevel,
	showLevel,
	onVisibilityChange,
	className,
	style,
}: {
	children: React.ReactNode;
	/**
	 * Only show until this view level
	 * Useful to hide menu items when space is limited
	 */
	hideLevel?: number;
	/**
	 * Only start view from this level
	 * Useful to replace menu items when space is limited
	 */
	showLevel?: number;
	onVisibilityChange?: (isVisible: boolean) => void;
	className?: string;
	style?: React.CSSProperties;
}) {
	const [{ shrinkLevel }] = useFloatingBar();

	// By default show
	let shouldHide = false;
	if (hideLevel !== undefined && shrinkLevel >= hideLevel) shouldHide = true;
	if (showLevel !== undefined && shrinkLevel < showLevel) shouldHide = true;

	// Notify caller
	const stableOnVisibilityChange = useStableCallback(onVisibilityChange);
	useEffect(() => {
		stableOnVisibilityChange?.(!shouldHide);
	}, [shouldHide, stableOnVisibilityChange]);

	return (
		<span
			className={`floating-bar-group ${shouldHide ? "floating-bar-group--hidden" : ""} ${
				className || ""
			}`}
			style={style}
			data-hide-level={hideLevel || undefined}
			data-show-level={showLevel || undefined}
		>
			{children}
		</span>
	);
}
